export default __webpack_public_path__ + "static/media/oil.30fc218d.jpg";